// extracted by mini-css-extract-plugin
module.exports = {"logo":"HeaderLogo_logo__t7Dhu"};